<template>
  <BaseModal :show="isShow">
    <div class="popup" style="width: 600px">
      <div class="popup-head">住所一覧</div>

      <div class="popup-body blue">
        <!--
              ****  メッセージ表示領域 ****-->
        <p class="errMsg title-ico ico-warning mb-5" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <h3>住所を選択してください。</h3>

        <!-- table -->
        <!-- ******************************************************************
              *  一覧検索                                                      *
              ****************************************************************** -->
        <div class="frm-row">
          <div class="frm-item grow left">
            <div
              class="frm-search frm-size-xl"
              :class="searchKey ? 'setvalue' : ''"
            >
              <span class="frm-label" style="margin-left: 0.5em">
                <img src="@/assets/images/TDSDC/icon_search.png" />
              </span>
              <input
                id="filter"
                type="search"
                size="43"
                class="frm-search-text"
                placeholder="検索キーワード"
                maxlength="255"
                v-model.trim="searchKey"
                ref="refSearchKey"
              />
            </div>
          </div>
        </div>
        <!-- table -->
        <div class="alignright">
          <p>{{ countStr }}</p>
        </div>
        <div class="table-wrap" style="margin-top: 0px; background-color: #fff">
          <div class="table-scroll-header">
            <table class="table-select single-select scroll">
              <colgroup>
                <!--住所コード-->
                <col style="width: 130px" />
                <!--住所-->
                <col style="width: auto" />
                <!---->
              </colgroup>
              <thead>
                <tr>
                  <th class="sort hover alignleft" @click="sortData('zipCode')">
                    郵便番号
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="sort.key == 'zipCode' && sort.isAsc ? 'on' : ''"
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'zipCode' && !sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover alignleft"
                    @click="sortData('fullAddress')"
                  >
                    住所
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'fullAddress' && sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'fullAddress' && !sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div
            class="table-scroll-body"
            style="height: 250px; background-color: #ffffff"
          >
            <table
              class="table-select single-select scroll"
              style="width: 100%; table-layout: fixed"
            >
              <colgroup>
                <!--住所コード-->
                <col style="width: 130px" />
                <!--住所-->
                <col style="width: auto" />
                <!---->
              </colgroup>
              <tbody id="addressList">
                <tr
                  v-for="address in displayAddressList"
                  :key="address.addressId"
                  :class="
                    address.addressId === selectedAddress?.addressId
                      ? 'selected'
                      : ''
                  "
                  @click="selectAddress(address, 'click')"
                >
                  <td>
                    {{ address.zipCode }}
                  </td>
                  <td>{{ address.fullAddress }}</td>
                </tr>
              </tbody>
            </table>
            <table class="table-select single-select" v-show="noDataFlag">
              <tbody>
                <tr>
                  <p class="noData-area">
                    {{ noDataMsg }}
                  </p>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="popup-foot blue">
        <div class="frm-btn-row footer-btn">
          <div class="frm-item grow center">
            <button
              tabindex="0"
              class="frm-btn strong large"
              type="button"
              @click="handleConfirm"
            >
              確定
            </button>
            <button
              tabindex="0"
              ref="cancelBtn"
              class="frm-btn large"
              type="button"
              @click="handleCancel"
            >
              キャンセル
            </button>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import {
  ref,
  reactive,
  defineEmits,
  defineProps,
  computed,
  watch,
  nextTick,
} from "vue";
import _ from "lodash";
import Common from "@/util/common.js";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { v4 as uuidv4 } from "uuid";
import BaseModal from "@/components/Base/BaseModal.vue";
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
    default: false,
  },
  addressList: {
    type: Array,
    default: () => [],
  },
  confirmText: {
    type: String,
    default: "はい",
  },
  cancelText: {
    type: String,
    default: "いいえ",
  },
});
const target = ref();
const searchKey = ref("");
const refSearchKey = ref(null);
const noDataMsg = ref(Common.getMessage("MTCL1118", ["住所情報"]));
const sort = reactive({
  key: "", // ソートキー
  isAsc: false, // 昇順ならtrue,降順ならfalse
});

const selectedAddress = ref();

const selectAddress = (address, type) => {
  selectedAddress.value = address;
  nextTick(() => {
    if (type !== "click") {
      const addressListDom = document.querySelector("#addressList");
      const selectdAddress = addressListDom.querySelector(".selected");
      selectdAddress.scrollIntoView();
    }
  });
};

// **********************************************
// 初期データリスト
// **********************************************
const addressList = ref([]);
const initData = () => {
  // Id追加,fullAddress追加
  const list = props.addressList.map((item) => ({
    ...item,
    addressId: uuidv4(),
    fullAddress: item.address + item.townAddition,
  }));
  // 重複排除
  const uniqueList = list.filter(
    (item, index, array) =>
      array.findIndex(
        (element) =>
          element.zipCode === item.zipCode &&
          element.address + element.townAddition ===
            item.address + item.townAddition
      ) === index
  );

  addressList.value = uniqueList;
};

// **********************************************
// 表示用データリスト
// **********************************************
const displayAddressList = computed(() => {
  let filteredList = addressList.value.filter(
    (item) =>
      item.zipCode?.toLowerCase().includes(searchKey.value.toLowerCase()) ||
      item.fullAddress?.toLowerCase().includes(searchKey.value.toLowerCase())
  );

  let sortedList = Common.listSort2(sort.key, sort.isAsc, filteredList);
  return sortedList;
});

// **********************************************
// 件数
// **********************************************
const countStr = computed(() => {
  return searchKey.value
    ? `${displayAddressList.value.length}/${addressList.value.length}件`
    : `${addressList.value.length}件`;
});

// NoData Flag
const noDataFlag = computed(() => {
  return displayAddressList.value.length === 0;
});

const sortData = (key) => {
  Common.sortData2(sort, key);
};

const errors = ref([]);

const emit = defineEmits(["confirm", "cancel"]);
const handleConfirm = () => {
  if (noDataFlag.value) {
    errors.value = [];
    errors.value.push(
      Common.createError("MTCL1034", Common.getMessage("MTCL1034", ["住所"]))
    );
    return;
  }
  emit("confirm", selectedAddress.value);
};
const handleCancel = () => {
  emit("cancel");
};

const cancelBtn = ref(null);

watch(
  () => props.isShow,
  (newVal) => {
    if (newVal) {
      // AddressList初期化
      initData();
      // エラーメッセージ初期化
      errors.value = [];
      // 検索キー初期化
      searchKey.value = "";
      // 初期フォーカス設定(検索条件)
      nextTick(() => {
        selectAddress(displayAddressList.value[0]);
        refSearchKey.value.focus();
      });
      // エラーメッセージを初期化
      errors.value = [];
    }
  }
);
</script>
